import Swal from 'sweetalert2';
import React, { useState } from 'react';
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import { useDispatch } from 'react-redux';
import { addNotification } from '../../store/reducers/uiReducer';

export const OrderActionButton = (props) => {
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const { confirmationText, tooltipText, className, onSucceed, onFailed, children, action } =
        props;

    const handleAction = async () => {
        try {
            const result = await Swal.fire({
                icon: 'question',
                title: 'Are you sure?',
                text: confirmationText,
                confirmButtonText: 'Yes, continue',
                cancelButtonText: 'No, cancel',
                confirmButtonClass: 'btn btn-primary mb-3',
                cancelButtonClass: 'btn btn-secondary ms-2 mb-3',
                showCancelButton: true,
                buttonsStyling: false
            });

            if (!result.isConfirmed) {
                setIsLoading(false);
                return;
            }

            const { success, message } = await action();
            setIsLoading(false);

            if (!success) {
                showNotification(message, 'warning');
                onFailed?.();
                return;
            }

            showNotification(message, 'success');
            onSucceed?.();
        } catch (error) {
            showNotification('Oops something went wrong.', 'danger');
            setIsLoading(false);
            onFailed?.();
        }
    };

    const showNotification = (message, type = 'primary') => {
        const title = 'Order';
        const icon = 'file-invoice';
        dispatch(
            addNotification({
                icon,
                type,
                title,
                message
            })
        );
    };

    const actionTooltip = (tooltipProps) => (
        <Tooltip id="action-tooltip" {...tooltipProps}>
            {tooltipText}
        </Tooltip>
    );

    return (
        <OverlayTrigger placement="top" delay={{ show: 250, hide: 400 }} overlay={actionTooltip}>
            <button onClick={handleAction} className={`${className}`} disabled={isLoading}>
                {children}
            </button>
        </OverlayTrigger>
    );
};
